import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import type { SdlBuilderFormValuesType, TemplateCreation } from "@src/types";

const deploySdl = atom<TemplateCreation | null>(null);
const sdlBuilderSdl = atom<SdlBuilderFormValuesType | null>(null);
const selectedSdlEditMode = atom<"yaml" | "builder">("yaml");
const sdlPreviewOpen = atomWithStorage<boolean>("sdlPreviewPaneOpen", false);

export default {
  deploySdl,
  sdlBuilderSdl,
  selectedSdlEditMode,
  sdlPreviewOpen
};
